/*
 * @Author: luting
 * @Date: 2022-04-15 16:33:33
 * @lastEditors: luting
 * @LastEditTime: 2023-02-21 10:22:56
 */
import produce from 'immer';
import {
  GET_DISKDATA,
  UPDATE_DISKDATA,
  GET_DISKID,
  FILTER_RECORD,
  GET_VISIBLE,
  UPDATE_RECORD,
  GET_RECORD,
} from '../constant';
import { diskConfigType } from 'root/pages/DiskConfig/diskTypes';

import _ from 'lodash';
import { diskStatus } from './types';

const defaultStates: diskStatus = {
  confirmDiskData: [],
  id: 0,
  record: null,
  visible: false,
  acitveKey: '1', // 非标tab的高亮项
  createDisable: false, // 如果非标数据中有一条包含/supos,/volumes则不允许创建挂载点
};

const disk = (state = { ...defaultStates }, action: any) => {
  switch (action.type) {
    case GET_DISKDATA: {
      const { confirmDiskData } = action.payload;
      const tempArr: any = [];
      let tempDisable = false; // 是否允许创建挂载点
      const copyData = confirmDiskData.map((item: diskConfigType) => {
        item.freeSize = Number(item?.freeSize);
        item.mountPoints.forEach((ele: any) => {
          ele.size = Number(ele.size);
          // 和minSize对比,添加实际最小值 initVal 2.21需求更改为最小值为当前值
          ele.minSize = Number(ele.minSize);
          // ele.initVal = ele.size > ele.minSize ? ele.size : ele.minSize;
          ele.initVal = ele.size;
        });
        tempArr.push([...item.mountPoints]);
        item.mountPoints = _.orderBy(item.mountPoints, ['suposPath'], 'desc');
        return item;
      });
      // 当数据中有其中一条挂载点是4.0的就不允许允许创建挂载点,disable就为true
      tempDisable = tempArr.some((e: any) => ['/home/supos/supos', '/volumes', '/backup'].includes(e.mountPoint));
      return {
        ...state,
        confirmDiskData: copyData,
        createDisable: tempDisable,
      };
    }
    case UPDATE_DISKDATA: {
      const { id, size, index } = action.payload;
      const { confirmDiskData } = state;
      const copyedConfirmDiskData = produce(confirmDiskData, (draftState) => {
        draftState.map((item: diskConfigType) => {
          const residueCount: number =
            item.totalSize - item.mountPoints.reduce((pre, cur) => pre + Number(cur.size), 0);
          if (item.id === id) {
            item.mountPoints[index].size = size;
          }
          item.freeSize = residueCount;
          return item;
        });
      });
      return {
        ...state,
        confirmDiskData: copyedConfirmDiskData,
      };
    }
    case GET_DISKID: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case FILTER_RECORD: {
      const { id } = action.payload;
      const { confirmDiskData } = state;
      const tempData = confirmDiskData.find((item) => {
        if (item.id === id) return true;
        return false;
      });

      return {
        ...state,
        record: tempData,
      };
    }
    case UPDATE_RECORD: {
      const { size, index } = action.payload;
      const { record } = state;
      const tempRecord = produce(record, (draftState: any) => {
        draftState.mountPoints[index].size = size;
      });
      return {
        ...state,
        record: tempRecord,
      };
    }
    case GET_RECORD: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case GET_VISIBLE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default disk;
